/**
 *  Used to get the correct OpenTicket selector class, which
 *  is added to every model's DOM element for easy selecting.
 */
export function getSelectorClass(modelType: string, guid: string): string {
    return `ot-elem-${modelType}-${guid}`;
}
